<template>
    <section class="contact-container">
        <b-row>
            <b-col class="fat-text">
                {{ $t('step2.yourContactInformation') }}
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <span :class="validName ? 'valid' : 'invalid'">{{ orderData.deliveryContact.address.name }}</span><br>
                {{ orderData.deliveryContact.address.street1 }}<br>
                <span v-if="orderData.deliveryContact.address.street2.length">
                    {{ orderData.deliveryContact.address.street2 }}<br>
                </span>
                {{ orderData.deliveryContact.address.zip }}
                {{ orderData.deliveryContact.address.city }}<br>
                {{ orderData.deliveryContact.address.country }}<br>
                <br>
                {{ orderData.email }}<br>
                {{ orderData.deliveryContact.phone }}<br>
                <a v-if="canEdit" @click="handleEdit" class="edit-contact-link">
                    <b-icon-pencil-square></b-icon-pencil-square>
                    {{ $t('step2.editContactInformationButton') }}
                </a>
                <error-messages :validation-errors="errors"></error-messages>
            </b-col>
        </b-row>
        <b-modal id="delivery-contact-modal"
                 :title="$t('contactEditor.title')"
                 :cancel-title="$t('common.cancel')"
                 :ok-title="$t('common.continue')"
                 @ok="handleSave"
        >
            <error-messages :validation-errors="errors"></error-messages>
            <b-form-group :label="$t('contactEditor.name')">
                <b-form-input
                    :value="deliveryContact.address.name"
                    :state="validateNameLength(deliveryContact.address.name)"
                    @input="deliveryContact.address.name = $event"
                ></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('contactEditor.street1')">
                <b-form-input
                    :value="deliveryContact.address.street1"
                    @input="deliveryContact.address.street1 = $event"
                ></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('contactEditor.street2')">
                <b-form-input
                    :value="deliveryContact.address.street2"
                    @input="deliveryContact.address.street2 = $event"
                ></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('contactEditor.zip')">
                <b-form-input
                    :value="deliveryContact.address.zip"
                    @input="deliveryContact.address.zip = $event"
                ></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('contactEditor.city')">
                <b-form-input
                    :value="deliveryContact.address.city"
                    @input="deliveryContact.address.city = $event"
                ></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('contactEditor.phone')">
                <b-form-input
                    :value="deliveryContact.phone"
                    @input="deliveryContact.address.phone = $event; deliveryContact.phone = $event;"
                ></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('contactEditor.country')">
                <b-form-input
                    disabled
                    :value="deliveryContact.address.country"
                    @input="deliveryContact.address.country = $event"
                ></b-form-input>
            </b-form-group>
        </b-modal>
    </section>
</template>
<script>
import { BIconPencilSquare } from "bootstrap-vue";
import ErrorMessages from "./ErrorMessages";

export default {
    name: 'ContactInformation',
    components: {
        ErrorMessages,
        BIconPencilSquare
    },
    props: {
        orderData: {},
        canEdit: {
            required: false
        }
    },
    computed: {
        errors() {
            if (this.validName) {
                return [];
            }

            this.handleEdit();
            return [
                this.$t('validate.nameTooLong')
            ]
        },
        validName() {
            const string = this.orderData.deliveryContact.address.name;
            return this.validateNameLength(string);
        }
    },
    data() {
        return {
            deliveryContact: {
                phone: null,
                address: {
                    name: null,
                    street1: null,
                    street2: null,
                    zip: null,
                    city: null,
                    country: null,
                    phone: null
                }
            }
        };
    },
    methods: {
        validateNameLength(string) {
            const length = string?.length;
            return length <= 35 && length > 0;
        },
        handleEdit() {
            this.deliveryContact = JSON.parse(JSON.stringify(this.orderData.deliveryContact));
            this.$bvModal.show('delivery-contact-modal');
        },
        handleSave() {
            this.$emit('save', this.deliveryContact);
        }
    },
}
</script>
<style scoped>

.contact-container {
    margin: 2rem 0;
}

.fat-text {
    font-weight: 500;
    text-transform: uppercase;
    font-size: 14px;
    margin-bottom: 0.5rem;
}

.edit-contact-link {
    font-weight: 500;
    line-height: 40px;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
}

@keyframes fadeIn {
    0% {
        background: rgba(255, 255, 255, 0);
    }

    100% {
        background: rgba(255, 255, 255, 0.5);
    }
}

.invalid {
    color: red;
}
</style>
